.smallNumber {
    font-size: 1.25rem;
    color: var(--mantine-color-dark-1);
}
